import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.6_@babel+core@7.29.7_react-dom@19.2.4_react@19.2.4__react@19.2.4_sass@1.100.0/node_modules/next/dist/client/image-component.js");
